module.exports = __webpack_public_path__ + "img/downloan.23779e02.svg";